<div class="c-slotcardProgress">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-slotcardProgress__container">
    <div
      class="c-slotcardProgress__background"
      theming
      themingGroup="slotcard"
      themingAsset="milestone-background"
      [themingOverride]="event?.assets">
      <div class="c-slotcardProgress__info">
        <div
          class="c-slotcardProgress__stamp"
          theming
          themingGroup="slotcard"
          themingAsset="milestone-stamp"
          [themingOverride]="event?.assets"></div>
        <div class="c-slotcardProgress__stamper"></div>
        <div class="c-slotcardProgress__text">
          @if (slotcardProgressModalData.properties.finished === false) {
            <span class="text title">{{ 'home.live-ops.slotcard.modal-milestone.title' | translate | uppercase }}</span>
            <span class="text subtitle">{{ 'home.live-ops.slotcard.modal-milestone.subtitle' | translate }}</span>
          }
          @if (slotcardProgressModalData.properties.finished === true) {
            <span class="text title">{{
              'home.live-ops.slotcard.modal-milestone.last-one.title' | translate | uppercase
            }}</span>
            <span class="text subtitle">{{
              'home.live-ops.slotcard.modal-milestone.last-one.subtitle' | translate
            }}</span>
          }

          <slotcom-button
            class="c-button--pink"
            data-testid="slotcard-new-stamp-button"
            (safeClick)="openSlotcard()"
            audioType="functionality">
            {{ 'home.buttons.go' | translate | uppercase }}
          </slotcom-button>
        </div>
      </div>
    </div>
  </div>
</div>
